'use client';
// We can't fork a `use client` boundary based on node-client vs browser-client.
// We need to fork one level deeper.
export { InstantValidationBoundaryContext, PlaceValidationBoundaryBelowThisLevel, RenderValidationBoundaryAtThisLevel, SlotMarker } from './impl';

//# sourceMappingURL=boundary.js.map